// eslint-disable-next-line import/prefer-default-export
export const avatarPlaceholder =
  // eslint-disable-next-line max-len
  'https://cn.hr.events.lvmh.com/object-storage/static001/events/GC702HNzdUXWPD/files/lC1aBf29usn7GU.png';
